import { useEffect, useState } from 'react';
import type { BillsData } from '@budget/core';
import { dataSource } from './source';
import { pollWithWake } from './kioskRefresh';

// The kiosk's bills, for its Bills and Upcoming widgets. Fetches only the
// Bills tab: a kiosk device token can't read the rest of the sheet (see
// KIOSK_TABS in api/sheet.ts), so the kiosk can't use useDashboard.

const REFRESH_MS = 60 * 60 * 1000;

export function useKioskBills(): {
  bills: BillsData['items'] | null;
  isLoading: boolean;
  error: string | null;
} {
  const [bills, setBills] = useState<BillsData['items'] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    async function tick() {
      try {
        const data = await dataSource.loadBills();
        if (!alive) return;
        setBills(data.items);
        setError(null);
      } catch (e) {
        if (alive) setError(e instanceof Error ? e.message : 'fetch failed');
      }
    }
    void tick();
    const stop = pollWithWake(tick, REFRESH_MS);
    return () => {
      alive = false;
      stop();
    };
  }, []);

  return { bills, isLoading: bills === null && error === null, error };
}
